export default [
  {
    id: 1,
    path: "/",
    name: "首页",
    entry: "Dashboard",
    icon: "home",
    private: true,
    exact: true,
    children: [
      {
        id: 9,
        path: "/health",
        name: "产业分析",
        entry: "Health",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 10,
        path: "/analysis",
        name: "产业数据",
        entry: "Analysis",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 23,
        path: "/poi",
        name: "POI指数",
        entry: "PoiIndex",
        icon: "minus",
        private: true,
        exact: true,
      },
    ],
  },
  {
    id: 11,
    path: "",
    name: "追踪",
    icon: "line-chart",
    children: [
      {
        id: 12,
        path: "/trend",
        name: "数据趋势",
        entry: "Trend",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 13,
        path: "/trendAd",
        name: "广告趋势",
        entry: "TrendAd",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 14,
        path: "/trendReport",
        name: "数据报告",
        entry: "TrendReport",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 15,
        path: "/assetsReport",
        name: "资产报告",
        entry: "AssetsReport",
        icon: "minus",
        private: true,
        exact: true,
      },
    ],
  },
  {
    id: 16,
    path: "",
    name: "品牌",
    icon: "tags-o",
    children: [
      {
        id: 17,
        path: "/brand",
        name: "行业应用",
        entry: "Brand",
        icon: "minus",
        private: true,
        exact: true,
      },
    ],
  },
  {
    id: 18,
    path: "",
    name: "洞察",
    icon: "tags-o",
    children: [
      {
        id: 21,
        path: "/tag",
        name: "标签探索",
        entry: "Tag",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 19,
        path: "/grid",
        name: "Grid Profile",
        entry: "Grid",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 20,
        path: "/graph",
        name: "知识图谱",
        entry: "Graph",
        icon: "minus",
        private: true,
        exact: true,
      },
      {
        id: 24,
        path: "/graphSearch",
        name: "时空图谱",
        entry: "GraphSearch",
        icon: "minus",
        private: true,
        exact: true,
      },
    ],
  },
  {
    id: 25,
    path: "/singapore",
    name: "Singapore",
    icon: "tags-o",
    entry: "Singapore",
    exact: true,
  },
  {
    id: 26,
    path: "/user",
    name: "权限",
    icon: "tags-o",
    entry: "User",
    exact: true,
  },
  {
    id: 800,
    path: "/health",
    name: "首页",
    icon: "tags-o",
    entry: "Health",
    exact: true,
  },
  {
    id: 100,
    path: "/logout",
    name: "退出",
    entry: "Passport/Logout",
    icon: "logout",
    exact: true,
  },
]
// export default [
//   {
//     id: 1,
//     path: "/",
//     name: "首页",
//     entry: "Dashboard",
//     icon: "home",
//     private: true,
//     exact: true,
//     children: [
//       {
//         id: 101,
//         path: "/health",
//         name: "产业分析",
//         entry: "Health",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 102,
//         path: "/analysis",
//         name: "产业数据",
//         entry: "Analysis",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 103,
//         path: "/poi",
//         name: "POI指数",
//         entry: "PoiIndex",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//     ],
//   },
//   {
//     id: 2,
//     path: "",
//     name: "追踪",
//     icon: "line-chart",
//     children: [
//       {
//         id: 201,
//         path: "/trend",
//         name: "数据趋势",
//         entry: "Trend",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 202,
//         path: "/trendAd",
//         name: "广告趋势",
//         entry: "TrendAd",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 203,
//         path: "/trendReport",
//         name: "数据报告",
//         entry: "TrendReport",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 204,
//         path: "/assetsReport",
//         name: "资产报告",
//         entry: "AssetsReport",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//     ],
//   },
//   {
//     id: 3,
//     path: "",
//     name: "品牌",
//     icon: "tags-o",
//     children: [
//       {
//         id: 301,
//         path: "/brand",
//         name: "行业应用",
//         entry: "Brand",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//     ],
//   },
//   {
//     id: 4,
//     path: "",
//     name: "洞察",
//     icon: "tags-o",
//     children: [
//       {
//         id: 401,
//         path: "/tag",
//         name: "标签探索",
//         entry: "Tag",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 402,
//         path: "/grid",
//         name: "Grid Profile",
//         entry: "Grid",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 403,
//         path: "/graph",
//         name: "知识图谱",
//         entry: "Graph",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//       {
//         id: 404,
//         path: "/graphSearch",
//         name: "时空图谱",
//         entry: "GraphSearch",
//         icon: "minus",
//         private: true,
//         exact: true,
//       },
//     ],
//   },
//   {
//     id: 8,
//     path: "/health",
//     name: "首页",
//     icon: "tags-o",
//     entry: "Health",
//     exact: true,
//   },
//   {
//     id: 9,
//     path: "/singapore",
//     name: "Singapore",
//     icon: "tags-o",
//     entry: "Singapore",
//     exact: true,
//   },
//   {
//     id: 200,
//     path: "/user",
//     name: "权限",
//     icon: "tags-o",
//     entry: "User",
//     exact: true,
//   },
//   {
//     id: 100,
//     path: "/logout",
//     name: "退出",
//     entry: "Passport/Logout",
//     icon: "logout",
//     exact: true,
//   },
// ]

